export enum Action {
  AddFavorite = 'AddFavorite',
  RemoveFavorite = 'RemoveFavorite',
}
